import { render, staticRenderFns } from "./product-grid.vue?vue&type=template&id=3e7f06b2&"
import script from "./product-grid.vue?vue&type=script&lang=js&"
export * from "./product-grid.vue?vue&type=script&lang=js&"
import style0 from "./product-grid.vue?vue&type=style&index=0&id=3e7f06b2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports